// eslint-disable import/no-anonymous-default-export
export default {
  dev: {
    API: {
      // baseURL: "https://devhubopsapis.innofulfill.com/smcs-webapp",
      // bffBaseURL: "https://devhubopsapis.innofulfill.com",
      bulkBaseURL: "https://smcs-dev.hutechweb.com/bulk-booking",
      baseURL: "https://smcs-dev.hutechweb.com/smcs-webapp",
      bffBaseURL: "https://smcs-dev.hutechweb.com",
      baseURLInnofulfill: "https://bookingapis.innofulfill.com",
      tatURL: "https://devapis.delcaper.com/routemaster/hubEstimate",
      delcaperBaseURL: "https://devapis.delcaper.com",
      delcaperBaseURLv2: "https://devapis2.delcaper.com",
      trackingURL: "https://devapis.delcaper.com/tracking/v2",
    },
    auth: {
      domain: "smcs-prod.hutechweb.com",
      oauthDomain: "SMCS_POOL.auth.us-east-1.amazoncognito.com",
      userPoolWebClientId: "5764umttfqiplob9e337ar0v0m",
      userPoolId: "us-east-1_TD8m0Yrs9",
      region: "us-east-1",
    },
  },
  qa: {
    API: {
      //baseURL: "https://qaapis.hubops.innofulfill.com/smcs-webapp",
      bulkBaseURL: "https://sandbox.api.bookings.innofulfill.com/bulk-booking",
      baseURL: "https://sandbox.api.bookings.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://sandbox.api.bookings.innofulfill.com",
      baseURLInnofulfill: "https://sandbox.bookingapis.innofulfill.com",
      tatURL: "https://qaapis.delcaper.com/routemaster/hubEstimate",
      delcaperBaseURL: "https://qaapis.delcaper.com",
      delcaperBaseURLv2: "https://qaapis2.delcaper.com",
      kestraBaseURL:
        "https://kestra.delcaper.com/api/v1/executions/pricing-engine/transform-rate-card-sandbox",
      trackingURL: "https://qaapis.hubops.innofulfill.com/tracking/v2",
      //
    },
    auth: {
      domain: "qaapis.hubops.innofulfill.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "a3e0iaciccfeln7no5b467ab5",
      userPoolId: "ap-south-1_xoRMaTXJu",
      region: "ap-south-1",
    },
  },
  uat: {
    API: {
      bulkBaseURL: "https://sandbox.api.bookings.innofulfill.com/bulk-booking",
      baseURL: "https://uatapis-hubops.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://uatapis-hubops.innofulfill.com",
      baseURLInnofulfill: "https://bookingapis.innofulfill.com",
      tatURL: "https://qaapis.delcaper.com/routemaster/hubEstimate",
    },
    auth: {
      domain: "smcs-uat.hutechweb.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "a3e0iaciccfeln7no5b467ab5",
      userPoolId: "ap-south-1_xoRMaTXJu",
      region: "ap-south-1",
    },
  },
  prod: {
    API: {
      bulkBaseURL: "https://apis.bookings.innofulfill.com/bulk-booking",
      baseURL: "https://apis.bookings.innofulfill.com/smcs-webapp",
      bffBaseURL: "https://apis.bookings.innofulfill.com",
      baseURLInnofulfill: "https://bookingapis.innofulfill.com",
      tatURL: "https://apis.delcaper.com/routemaster/hubEstimate",
      delcaperBaseURL: "https://apis.delcaper.com",
      delcaperBaseURLv2: "https://apis2.delcaper.com",
      kestraBaseURL:
        "https://kestra.delcaper.com/api/v1/executions/pricing-engine/transform-rate-card",
      trackingURL: "https://apis-hubops.innofulfill.com/tracking/v2",
    },
    auth: {
      domain: "smcs-prod.hutechweb.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "4q270kj0hhe1jimi5tbopv2vts",
      userPoolId: "ap-south-1_7Q0AtPCUn",
      region: "ap-south-1",
    },
  },
};
